import { useEffect, useState } from "react";
import { useListManager } from "../../../contexts/list.manager";
import { useLocation, useNavigate } from "react-router-dom";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { TbCategory, TbRosetteDiscount } from "react-icons/tb";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import { BsToggles, BsToggles2 } from "react-icons/bs";
import { MdOutlineCategory } from "react-icons/md";
import ListLicenseFeatures from "./ListLicenseFeatures";
import { FormLicenseFeature } from "./FormLicenseFeature";

export function LicenseFeatures({ ...props }) {
   const { lineSelected } = useListManager();
   const [searchText, setSearchText] = useState("");
   const [filters, setFilters] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      if (location.state?.deletedId) {
         setRefreshKey((k) => k + 1);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<BsToggles size={20} />}
               title="Funcionalidades de licença"
               navigate={"/licenses/features/new"}
               description="Buscar"
               buttonLabel="Adicionar Funcionalidade"
            >
               <SearchInput
                  value={searchText}
                  placeholder="Buscar"
                  onChange={({ target }) => setSearchText(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
               />
            </SearchContainer>
            <Container>
               <ListLicenseFeatures filters={filters} refreshKey={refreshKey} />
            </Container>
         </div>
         <ConsultaFormContainer>
            <FormLicenseFeature licenseFeature={lineSelected} type="consulta" />
         </ConsultaFormContainer>
      </div>
   );
}